/**
 * アプリケーションのルートコンポーネント
 * エントリーポイント - ロジックとUIを組み合わせる
 */

import { useApp } from './hooks/useApp';
import { AppLayout } from './components/AppLayout';

export const Index = () => {
  const props = useApp();

  return <AppLayout {...props} />;
};
